(function () {
    var ePressJournals = {
        vPort: 'screen-md',
        isMobile: false,
        $sliderContainer: document.querySelector('.epress-journals__slider'),
        $slider: $('.epress-journals__slider .owl-carousel'),

        init: function () {
            ePressJournals.controls();
        },
        controls: function () {
            $(document).on(UX.ePressJournals.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                ePressJournals.isMobile = true;
                ePressJournals.simplebar(false);
                ePressJournals.changeOrder();
            });

            $(document).on(UX.ePressJournals.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                ePressJournals.isMobile = false;
                ePressJournals.simplebar(true);
            });
        },
        simplebar: function (destroy) {
            if (destroy) {
                const simplebarContentElem = ePressJournals.$sliderContainer.querySelector('.simplebar-content');
                if (!simplebarContentElem) return;
                const simplebarContent = simplebarContentElem.innerHTML;
                ePressJournals.$sliderContainer.innerHTML = simplebarContent;
                ePressJournals.$sliderContainer.dataset.simplebar = null;
                ePressJournals.$sliderContainer.removeAttribute('data-simplebar');
            } else {
                new SimpleBar(ePressJournals.$sliderContainer, {
                    autoHide: false,
                });
            }
        },
        changeOrder: function () {
            var randomNum = Math.floor(Math.random() * 3) + 1;
            ePressJournals.$slider.find(`.slide-item:nth-child(${randomNum})`).addClass('order-1');
        },
    };

    UX.ePressJournals = ePressJournals;
    if ($('.epress-journals').length) {
        UX.ePressJournals.init();
    }
})();
